<script lang="ts">
  import {onDestroy} from 'svelte';
  import type {SvelteComponent} from 'svelte';

  import {recaptcha, apiUrl} from 'Store/InvestorFlowStore';

  import RecaptchaV3 from 'Components/Common/RecaptchaV3.svelte';

  export let personalContainer: HTMLElement;
  export let recaptchaInstance: SvelteComponent;

  let recaptchaBox: HTMLElement;

  const reCaptchaWidth = 304;

  const scaleRecaptcha = new ResizeObserver(entries => {
    if (entries.length === 0) return;

    // Recaptcha iframe width is 304px by default with regular options setup
    const rect = entries[0].contentRect;

    // Exclude viewports when input's width is dynamic with screen size.
    // 415px limit need to be included as a limit for not having undesired oversized re-captcha iframe
    if (!(window.innerWidth >= 415 && window.innerWidth <= 767)) {
      const recaptchaScale = rect.width / reCaptchaWidth;
      if (recaptchaBox) {
        recaptchaBox.style.transform = `scale(${recaptchaScale})`;
      }
    }
  });

  $: if (personalContainer) {
    scaleRecaptcha.observe(personalContainer);
  }

  onDestroy(() => {
    scaleRecaptcha.disconnect();
  });
</script>

<RecaptchaV3
  bind:this={recaptchaInstance}
  bind:recaptchaV2Box={recaptchaBox}
  baseUrl={$apiUrl}
  recaptchaSiteKey={$recaptcha.sitekey}
  invisibleRecaptchaSiteKey={$recaptcha.sitekey_v3}
/>
